import dayjs from 'dayjs';
import { FC, useMemo } from 'react';

import { ActiveUnit, EquipmentType } from 'types';

export const ChassisDetails: FC<{ units?: ActiveUnit[] }> = ({ units = [] }) => {
  const chasses = useMemo(() => {
    return units.filter(unit => unit.equipmentType === EquipmentType.CHASSIS || unit.sizeType?.endsWith('TR'));
  }, [units]);

  return !chasses.length ? null : (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>CHASSIS DETAILS</h4>
      </div>
      <div className="card-body">
        {chasses.map(chassis => (
          <div className="grid-4 p-2" key={chassis.id}>
            <div>
              <h6 className="text-dark font-weight-regular">CHASSIS NUMBER</h6>
              <p className="text-black" data-cy="chassis-unit-number">
                {chassis.unitNumber ?? 'N/A'}
              </p>
            </div>
            <div>
              <h6 className="text-dark font-weight-regular">LICENSE PLATE</h6>
              <p className="text-black" data-cy="chassis-license-plate">
                {chassis.licensePlate ?? 'N/A'}
              </p>
            </div>
            <div>
              <h6 className="text-dark font-weight-regular">LP EXPIRATION</h6>
              <p className="text-black" data-cy="chassis-license-plate-expiration-date">
                {!chassis.licensePlateExpirationDate
                  ? 'N/A'
                  : dayjs(chassis.licensePlateExpirationDate).format('MM/YYYY')}
              </p>
            </div>
            <div>
              <h6 className="text-dark font-weight-regular">FMCSA DATE</h6>
              <p className="text-black" data-cy="chassis-fmcsa-date">
                {!chassis.fmcsaDate ? 'N/A' : dayjs(chassis.fmcsaDate).format('MM/YYYY')}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
